<ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="desktopTemplate">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #nohomefilter>
    <ng-container [ngSwitch]="desktopTemplate">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="nohomefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #homemodeMobile>
    <div class="tmp-extra-wrapper-mobile">
        <div class="tmp-section-wrapper-mobile">
            <clever-selectionbtn [title]="'Reiseart'" [isMultiselect]="false" [list]="searchTypes"
                (sendRes)="cruisesearchtyperesult($event)">
            </clever-selectionbtn>
            <clever-selectionbtn [title]="'Reisedauer'" [isMultiselect]="false" [list]="reiseDauer"
                (sendRes)="cruisedurationresult($event)">
            </clever-selectionbtn>
            <clever-selectionbtn [title]="'Max. Anzahl Passagiere'" [isMultiselect]="false" [list]="maxPass"
                (sendRes)="cruisemaxanzpassresult($event)">
            </clever-selectionbtn>
            <clever-selectionbtn [title]="'Kabinenkategorie'" [isMultiselect]="false" [list]="cabinCat"
                (sendRes)="cruisecabincatresult($event)">
            </clever-selectionbtn>
            <clever-selectionbtn [title]="'Max. Gesamtpreis'" [isMultiselect]="false" [list]="gsPrice"
                (sendRes)="cruisemaxpriceresult($event)">
            </clever-selectionbtn>
            <clever-selectionbtn [title]="'Bordsprache'" [isMultiselect]="false" [list]="language"
                (sendRes)="cruiseboardlanguageresult($event)">
            </clever-selectionbtn>
        </div>
    </div>
    <div class="tmp-footer-mobile">
        <button class="mb1" (click)="resetAllExtra()" matRipple>
            <span multilang>Alle Filter löschen</span>
        </button>
        <span multilang></span>
    </div>
</ng-template>

<ng-template #homefilterdesk>
    <div class="tmp-extra-wrapper">
        <div class="tmp-section-wrapper">
            <clever-selectionbtn [title]="'Reiseart'" [isMultiselect]="false" [list]="searchTypes"
                (sendRes)="cruisesearchtyperesult($event)">
            </clever-selectionbtn>
            <clever-selectionbtn [title]="'Reisedauer'" [isMultiselect]="false" [list]="reiseDauer"
                (sendRes)="cruisedurationresult($event)">
            </clever-selectionbtn>
        </div>
        <mat-divider vertical class="custom-divider-vertical"></mat-divider>
        <div class="tmp-section-wrapper">
            <clever-selectionbtn [title]="'Max. Anzahl Passagiere'" [isMultiselect]="false" [list]="maxPass"
                (sendRes)="cruisemaxanzpassresult($event)">
            </clever-selectionbtn>
            <clever-selectionbtn [title]="'Kabinenkategorie'" [isMultiselect]="false" [list]="cabinCat"
                (sendRes)="cruisecabincatresult($event)">
            </clever-selectionbtn>
        </div>
        <mat-divider vertical class="custom-divider-vertical"></mat-divider>
        <div class="tmp-section-wrapper">
            <clever-selectionbtn [title]="'Max. Gesamtpreis'" [isMultiselect]="false" [list]="gsPrice"
                (sendRes)="cruisemaxpriceresult($event)">
            </clever-selectionbtn>
            <clever-selectionbtn [title]="'Bordsprache'" [isMultiselect]="false" [list]="language"
                (sendRes)="cruiseboardlanguageresult($event)">
            </clever-selectionbtn>
        </div>
    </div>
    <div class="tmp-footer">
        <span multilang></span>
        <div class="tmp-flexy">
            <button class="tmp-reset-btn" (click)="resetAll()" matRipple>
                <span multilang>Alle Filter löschen</span>
            </button>
            <button class="tmp-close-btn" (click)="closeextras()" matRipple>
                <span multilang>Schließen</span>
                <mat-icon>arrow_drop_up</mat-icon>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #nohomefilterdesk>
    <div class="nohome-wrapper-desk">
        <ng-container *ngTemplateOutlet="myfilters"></ng-container>
    </div>
</ng-template>

<ng-template #nohomemodeMobile>
    <div class="nohome-wrapper">
        <ng-container *ngTemplateOutlet="myfilters"></ng-container>
    </div>
</ng-template>

<ng-template #myfilters>
    <clever-selectionbtn [title]="'Reiseart'" [isCheckBox]="true" [isMultiselect]="false" [list]="searchTypes"
        (sendRes)="cruisesearchtyperesult($event)">
    </clever-selectionbtn>
    <clever-selectionbtn [title]="'Reisedauer'" [isCheckBox]="true" [isMultiselect]="false" [list]="reiseDauer"
        (sendRes)="cruisedurationresult($event)">
    </clever-selectionbtn>
    <clever-selectionbtn [title]="'Max. Anzahl Passagiere'" [isCheckBox]="true" [isMultiselect]="false" [list]="maxPass"
        (sendRes)="cruisemaxanzpassresult($event)">
    </clever-selectionbtn>
    <clever-selectionbtn [title]="'Kabinenkategorie'" [isCheckBox]="true" [isMultiselect]="false" [list]="cabinCat"
        (sendRes)="cruisecabincatresult($event)">
    </clever-selectionbtn>
    <clever-selectionbtn [title]="'Max. Gesamtpreis'" [isCheckBox]="true" [isMultiselect]="false" [list]="gsPrice"
        (sendRes)="cruisemaxpriceresult($event)">
    </clever-selectionbtn>
    <clever-selectionbtn [title]="'Bordsprache'" [isCheckBox]="true" [isMultiselect]="false" [list]="language"
        (sendRes)="cruiseboardlanguageresult($event)">
    </clever-selectionbtn>

    <ng-container *ngTemplateOutlet="specialsearch"></ng-container>

</ng-template>

<ng-template #specialsearch>
    <div class="tmp-section-item-wrapper">
        <span multilang class="tmp-section-title">Specials suchen</span>
        <div class="tmp_srchwrp">
            <input type="text" placeholder="Promotion / Special-Preise Code" class="tmpangebotsktvinput"
                [(ngModel)]="specialcode" (ngModelChange)="setSpecial($event)">
            <button class="tmp_srchbtn" matRipple (click)="makeSearch()"><span multilang>Suchen</span></button>
        </div>
    </div>
</ng-template>

<ng-template #skloading>
    <div style="width: 100%;display: flex;flex-direction: column;margin-bottom: 1rem;">
        <div class="skeleton" style="height: 20px;width: 200px;margin-top: .5rem;"></div>
        <div class="skeleton" style="height: 20px;width: 150px;margin-top: .5rem;"></div>
        <div class="skeleton" style="height: 20px;width: 100px;margin-top: .5rem;"></div>
    </div>
</ng-template>